export default "__VITE_ASSET__ES4HjEWN__"